var render = function render(){var _vm=this,_c=_vm._self._c;return _c('viewer',{ref:"viewer",staticClass:"viewer",attrs:{"options":_vm.options,"images":[_vm.src]},on:{"inited":_vm.inited}},[_c('img',{directives:[{name:"show",rawName:"v-show",value:(false),expression:"false"}],key:_vm.src,attrs:{"src":_vm.src}})])
}
var staticRenderFns = []

export { render, staticRenderFns }